var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BillProduct',{attrs:{"billModel":_vm.billModel,"grouped-imei-by-product":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }